function Curriculum() {
  return (
    <section className="py-16 px-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-14">
          <h1 className="text-5xl font-bold text-blue-900 mb-4">
            Curriculum
          </h1>

          <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Capitol Public School is affiliated to the Central Board of
            Secondary Education (CBSE), New Delhi, and follows a holistic,
            student-centered curriculum designed to nurture academic excellence,
            creativity, leadership, and life skills.
          </p>
        </div>

        {/* CBSE Section */}
        <div className="bg-white rounded-3xl shadow-lg p-8 mb-10 border-l-4 border-yellow-400">
          <h2 className="text-3xl font-bold text-blue-900 mb-5">
            CBSE Affiliation
          </h2>

          <p className="text-gray-700 leading-relaxed">
            The school is affiliated to the Central Board of Secondary
            Education (CBSE), New Delhi. The medium of instruction is English.
            Our mission emphasizes service, challenges, adventure, academic
            excellence, creativity, and a positive attitude.
          </p>

          <p className="text-gray-700 leading-relaxed mt-4">
            We prepare young minds to become future leaders who contribute to
            economic, industrial, and social development of the country.
          </p>
        </div>

        {/* Montessori */}
        <div className="bg-white rounded-3xl shadow-lg p-8 mb-10 border-l-4 border-blue-900">
          <h2 className="text-3xl font-bold text-yellow-500 mb-5">
            Montessori Method Approach
          </h2>

          <blockquote className="italic text-gray-600 border-l-4 border-yellow-400 pl-4 mb-6">
            “We must help the child to liberate himself from his defects without
            making him feel his weakness.” — Dr. Maria Montessori
          </blockquote>

          <p className="text-gray-700 leading-relaxed mb-4">
            Our Montessori classrooms are carefully prepared environments where
            children learn through exploration, creativity, and purposeful
            activities guided by trained educators.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            Early childhood education is given utmost importance with colorful,
            engaging, and secure learning spaces that make children feel happy,
            safe, and confident.
          </p>

          <p className="text-gray-700 leading-relaxed">
            The Montessori method develops not only intellectual abilities but
            also self-discipline, independence, social awareness, and multiple
            intelligences among students.
          </p>
        </div>

        {/* Primary Section */}
        <div className="bg-white rounded-3xl shadow-lg p-8 mb-10 border-l-4 border-yellow-400">
          <h2 className="text-3xl font-bold text-blue-900 mb-5">
            Primary Section
          </h2>

          <p className="text-gray-700 leading-relaxed">
            Capitol Public School follows an Innovative Learning Curriculum for
            Classes I and II based on the principle of “learning by doing.”
          </p>

          <p className="text-gray-700 leading-relaxed mt-4">
            This curriculum promotes experiential learning, helping children
            build a strong academic and emotional foundation while developing
            confidence, creativity, and identity.
          </p>
        </div>

        {/* Secondary Section */}
        <div className="bg-white rounded-3xl shadow-lg p-8 border-l-4 border-blue-900">
          <h2 className="text-3xl font-bold text-yellow-500 mb-5">
            Secondary & Senior Secondary
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            From Grade VI onwards, students follow the CBSE curriculum with
            English as the medium of instruction.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Hindi and Kannada are offered as second languages, while Kannada,
            Hindi, and Sanskrit are available as third languages up to Class
            VIII.
          </p>

          <h3 className="text-2xl font-semibold text-blue-900 mb-4">
            Curriculum Objectives
          </h3>

          <div className="grid md:grid-cols-2 gap-5">

            {[
              "Motivate and engage learners",
              "Enable smooth progression from primary to higher levels",
              "Develop personal, learning, and thinking skills",
              "Prepare students for higher education and careers",
              "Encourage responsibility towards health and safety",
              "Promote intellectual, social, emotional, and physical development",
              "Build confidence, aspirations, and leadership qualities",
              "Prepare students for AISSE (Class X CBSE Examination)"
            ].map((item, index) => (
              <div
                key={index}
                className="bg-gray-100 rounded-xl p-5 hover:shadow-md transition"
              >
                <p className="text-gray-700 font-medium">
                  ✔ {item}
                </p>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}

export default Curriculum;